// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__1kRTM","active":"Tabs_active__uGUKx","disabled":"Tabs_disabled__9UVYj","tab-content":"Tabs_tab-content__r0lB4"};